<template>
    <div class="cart-item__row fullcart-item">
    <div class="cart-item__row-product">

      <div class="cart-item__delete"></div>

      <div class="cart-item__thumbnail-container">
        <a href="#" @click.prevent="handleProductLink">
          <img v-bind:src="item.product.thumbnailImageUrl" class="cart-item__thumbnail" alt="">
        </a>
      </div>

      <div class="cart-item__display-name-and-note">

        <a href="#" @click.prevent="handleProductLink" class="cart-item__display-name">
           <span v-html="item.product.displayName"></span>
           <span v-if="item.product.defaultSku.customerFriendlySize">, {{ item.product.defaultSku.customerFriendlySize }}</span>
        </a>

        <div
          v-if="hasPreference"
          class="cart-item__preference">
          {{ item.purchasePreference.text }}
        </div>

        <div class="cart-item__note-container d-none d-lg-block cart-item__note">
          <div class="cart-item__note-row">
            <span class="cart-item__note-text" v-if="item.itemNote">{{ item.itemNote }}</span>
          </div>
        </div>

      </div>

      <!-- COVID-19 / CTH-1615 Commented out next 4 lines -->
      <!-- <div class="cart-item__note-sub-mobile d-lg-none">
        <span v-if="item.allowSubstitutes">Allow Subs</span>
        <span v-else>No Subs</span>
      </div> -->
      <div class="cart-item__note-sub-mobile-text d-lg-none" v-if="item.itemNote">
        <span class="cart-item__note-text">{{ item.itemNote }}</span>
      </div>
      <!-- COVID-19 / CTH-1615 Commented out next 4 lines -->
      <!-- <div class="cart-item__substitution d-none d-lg-block">
        <span v-if="item.allowSubstitutes">Allow Subs</span>
        <span v-else>No Subs</span>
      </div> -->

      <div class="cart-item__quantity">
        <span v-if="item.product.defaultSku.customerPurchaseChoice == 'WEIGH'">{{ item.weight }} lb</span>
        <span v-else>Qty: {{ item.quantity }}</span>
      </div>

      <div class="cart-item__adjustments-toggle-container"></div>

      <div class="cart-item__price-container" v-if="item.quantity>1">
        <div class="cart-item__total-price">{{ item.totalLineItemPrice.formattedAmount }}</div>
        <div class="cart-item__each-price" >
          <span>{{ item.totalUnitPrice.formattedAmount }}/each</span>
        </div>
      </div>
      <div class="cart-item__price-container" v-else>
        <div class="cart-item__total-price">{{ item.totalLineItemPrice.formattedAmount }}</div>
      </div>

    </div>

    <div class="cart-item__bottom-bar">
      <section></section>
    </div>

  </div>

</template>

<script>
import CouponDetailModal from '../CouponDetailModal'
import { PRODUCT_CLICK_EVENT } from "../../utilities/constants";

export default {
  name: 'CartItemHistory',
  components: {
    'coupon-detail-modal': CouponDetailModal
  },
  props: {
    listname: {
      type: String,
      default: ""
    },
    reco: {
      type: String,
      default: "default"
    },
    position: {
      type: Number,
      default: 1
    },
    cartItem: {
      type: Object
    },
    categoryIndex: {
      type: Number
    },
    itemIndex: {
      type: Number
    },
    bucket: {
      type: String,
      default: 'cart' // cart, orderAddOns. Used for figuring out how many items are in a specific bucket
    },
    productLinkDestination: {
      type: String,
      default: 'link' // link, modal. A switch that choose how to handle the destination of clicking on a link in the product card
    }
  },
  computed: {
    // Make a local copy of the item for modification
    item: function () {
      return JSON.parse(JSON.stringify(this.cartItem))
    },
    hasPreference() {
      return this.item.purchasePreference && this.item.purchasePreference.text;
    },
  },
  methods: {
    handleProductLink () {
      this.gtmClick(PRODUCT_CLICK_EVENT, this.item, this.bucket, this.listname, '', 'cartHistory', this.position, this.reco)
      this.gtmClick('e_productDetailView', this.item, this.bucket, this.listname, '', 'cartHistory', this.position, this.reco)
      this.hupOpenModal({
        modalId: 'product-detail',
        productId: this.item.product.productId,
        bucket: this.bucket
      })
    }
  }
}
</script>

<style lang="scss" scoped>

@import "../../assets/lib";

.cart-item__row {
  padding: 8px 0;
  border-bottom: 1px solid #ccc;
  position: relative;
  min-height: 6rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  // z-index: 0;
  background-color: #fff;
}

.cart-item__row:last-of-type {
  border-bottom: 0;
}

.cart-item__row-product {
  display: grid;
  grid-template-rows: auto auto auto auto;
  grid-template-columns: auto 48px 1fr auto;
  grid-gap: 4px;
  transition: all 0.125s ease-in-out;
}

.cart-item__delete {
  grid-column: 1;
  grid-row: 1 / 4;
  margin-right: 16px;
}

.cart-delete-item {
  opacity: 0.4;
  font-size: 1.75rem;
}

.cart-item__delete-confirm {
  text-align: center;
}

.cart-item__delete-confirm.isDeleting {
  position: absolute;
  // z-index: 50;
  background: #fff;
  left: 16px;
  z-index: 0;
}

.cart-item__delete-confirm-message {
  font-weight: 600;
  margin-bottom: 8px;
}

// Elements

.cart-item__thumbnail-container {
  grid-row: 1 / 3;
  grid-column: 2 / 3;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
}

.cart-item__thumbnail {
  width: 100%;
  min-height: 48px;
}

.cart-item__display-name-and-note {
  grid-row: 1 / 3;
  grid-column: 3 / 4;
  font-size: 13px;
  flex-grow: 1;
  min-width: 0;
}

.cart-item__display-name {
  overflow: hidden;
  display: block;
}

.cart-item__preference {
  font-size: 12px;
  margin-top: 8px;
}

.cart-item__note-sub-mobile {
  grid-row: 3;
  grid-column: 2 / 5;
  display: flex;
  font-size: 13px;
}

.cart-item__note-sub-mobile-text {
  grid-row: 4;
  grid-column: 3;
  display: flex;
  font-size: 13px;
}

.cart-item__note-container {
  margin-top: 16px;
}

.cart-item__note-text {
  font-style: italic;
}

// When an item has a note on mobile the layout changes
.cart-item__has-note {
  flex-direction: column-reverse;
  overflow: hidden;
}

.cart-item__price-container {
  grid-row: 1;
  grid-column: 4;
  text-align: right;
  width: 70px;
  flex-shrink: 0;
  justify-self: flex-end;
  min-height: 37px;
  flex-basis:94px;
}

.cart-item__total-price {
  font-weight: bold;
  position: relative;
  font-size: 14px;
}

.cart-item__total-price-disabled:after {
  width: 3.5rem;
  content: "";
  display: block;
  height: 2px;
  right: -4px;
  transform: rotate(-20deg);
  top: 40%;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
}

.cart-item__sale-price {
  color: $color-heb-primary;
  font-weight: bold;
}

.cart-item__each-price {
  font-size: 11px;
  color: #4a4a4a;
}

.cart-item__adjustments-toggle {
  display: none;
}

@media screen and (max-width: $breakpoint-tablet){
  input.cart-item__input-quantity.notActive {
    border-radius: 4px !important;
  }
}

.cart-item__quantity {
  grid-row: 2;
  grid-column: 4;
  justify-content: flex-end;
  text-align: right;
  z-index: 20;
  position: relative;
  flex-shrink: 0;
  flex-basis:140px;
}

.cart-item__row-product.disabled .paddle-dropshadow {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
}

.cart-item__quantity-placeholder {
  position: absolute;
  right: 0;
}

.btn-decrement,
.btn-increment {
  height: 40px;
  width: 40px;
  border: 1px solid #ccc;
  text-align: center;
  padding: 0;
  display: inline-block;
  background-color: #fff;
  color: $color-text-standard;

  &:hover,
  &:active,
  &:focus {
    background-color: #e6e6e6;
    color: $color-text-standard;
  }

  &.disabled {
    background-color: #ececec;
    color: #8b8b8b;
    cursor: default;
  }
}

.btn.cart-item__input-quantity {
  box-sizing: border-box;
  width: 3rem;
  height: 40px;
  line-height: 40px;
  border: 1px solid #ccc;
  padding: 0;
  -moz-user-select: text;
  -webkit-user-select: text;
  cursor: text;

  &:hover,
  &:active,
  &:focus {
    color: $color-text-standard;
    background-color: none;
    box-shadow: none;
  }
}

.cart-item__input-quantity.cart-item__estimated-weight{
  width: 4rem;
}

.cart-item__row-product.disabled .cart-item__row__disabled-overlay {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.4);
}

.cart-item__row-product.isDeleting {
  transform: translateX(280px);
}

@media screen and (min-width: $breakpoint-desktop){
  .fullcart-item {

    .btn-coupon{
      margin-left: 8px;
    }

    .cart-item__row-product {
      display: flex;
      align-items: center;
      flex-grow: 1;
      margin-bottom: 8px;
    }

    .cart-item__display-name {
      font-size: 16px;
      overflow: hidden;
      flex-grow: 1;
      flex-shrink: 1;
      text-align: left;
      max-height: 3rem;
    }

    .cart-item__preference {
      font-size: 14px;
    }

    .cart-item__notes-section {
      font-size: 14px;
    }

    .cart-item__thumbnail-container {
      width: 64px;
      height: 64px;
      margin-right: 16px;
    }

    .cart-item__quantity {
      text-align: center;
    }

    .cart-item__quantity-placeholder {
      position: relative;
      right: auto;
    }

    .btn.cart-item__input-quantity {
      width: 3rem;
      border: 1px solid #ccc;
      padding: 0;
      cursor: text;

      &:hover,
      &:active,
      &:focus {
        color: $color-text-standard;
        background-color: none;
        cursor: text;
      }
    }

    .cart-item__substitution {
      margin-right: 16px;
      margin-left: 16px;
      flex-basis:80px;
      white-space: nowrap;
      text-align:right;

      label{ margin-bottom: 0}
    }

    .cart-total-section {
      width: 25%;
    }

    .cart-item__total-price {
      font-size: 1.125rem;
    }

    .cart-item__each-price {
      font-size: 12px;
    }

    .cart-item__bottom-bar {
      display: flex;
      justify-content: space-between;
    }

    .cart-item__adjustments-toggle-container {
      width: 16px;
      margin-right: 8px;
      flex-shrink: 0;
    }

    .cart-item__adjustments-toggle {
      display: block;
    }

    .cart-item__adjustments {
      color: $color-heb-red;
      width: 300px;
      text-align: right;
    }

    .cart-item__adjustment-circle {
      border: 1px solid rgb(51, 51, 51);
      border-radius: 16px;
      width: 16px;
      height: 16px;
      padding-left: 3px;
      line-height: 1;
    }

    .cart-item__adjustment-type {
      font-weight: normal;
      // display: inline-block;
    }

    .cart-item__adjustment-value {
      font-weight: bold;
      padding-left: 30px;
      // display: inline-block;
    }
  }


}
</style>
